import { createReduxSagaActionSubtypes as createSubtypes } from '@/utils/create-redux-saga-action-subtypes';

export const OpportunitiesActionTypes = {
  FETCH_OPPORTUNITIES: createSubtypes('opportunities|fetchAll'),
  FETCH_OPPORTUNITY: createSubtypes('opportunities|fetchById'),
  CHANGE_STAGE: createSubtypes('opportunities|changeStatus'),
  ASSIGN_SALES_REPRESENTATIVE: createSubtypes('opportunities|assignSales'),
};
